import { useIsOneStone } from 'digital-settings/shared/hooks'
import { useExperiment } from 'shared/experiment'

import { useDeusExMachina } from '~/domains/platform/infra/deus-ex-machina/hocs/with-deus-ex-machina'

export function useIsWebhookSettingsEnabled() {
  const isOneStone = useIsOneStone()
  const { deusExMachina } = useDeusExMachina()
  const subjectId = deusExMachina?.subject?.id ?? ''
  const { isFeatureFlagEnabled, ...rest } = useExperiment(subjectId, 'pjvc_webhook_settings_enable_web')

  return { isFeatureFlagEnabled: isFeatureFlagEnabled && isOneStone, ...rest }
}
